export const DEFAULT_GIG_APPLICATION_MSG = 'Hi there, I would like to purchase your Gig'
